<template>
  <div class="file_name">
    <img src="../assets/左_left.png" />
    <img src="../assets/右_right (1).png" /> headrace
  </div>
</template>

<script>
export default {
  name: "Headrace",
};
</script>

<style lang="less" scoped>
.file_name {
  height: 49px;
  line-height: 49px;
  font-size: 16px;
  font-weight: 600;
  padding-left: 10px;
  color: #545454;
  display: flex;
  align-items: center;
  background-color: rgba(212, 206, 205, 0.1);
  border-bottom: 1px solid #efefef;
  img {
    height: 26px;
    margin-right: 16px;
  }
}
</style>
